module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (131).66151fb1.jpg";